import { Button, IconButton, Skeleton, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogOuter = styled("div")(({ theme }) => ({
  pointerEvents: "none",
  position: "fixed",
  display: "flex",
  justifyContent: "end",
  alignItems: "end",
  inset: theme.spacing(2),
  top: "auto",
  zIndex: 99999999,
  [theme.breakpoints.down("sm")]: {
    inset: 0,
  },
}));

export const DialogWrapper = styled("div")(({ theme }) => ({
  pointerEvents: "auto",
  background: theme.custom.palette.semantic.modalBg,
  width: "440px",
  minHeight: "630px",
  maxHeight: "765px",
  ["@media screen and (min-height: 765px)"]: {
    height: "100%",
  },
  borderRadius: theme.custom.radius[1],
  boxShadow: theme.shadows[4],
  zIndex: 99999999,
  opacity: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    left: 0,
    top: 0,
    bottom: 0,
    boxShadow: "unset",
    borderRadius: "0px",
    maxHeight: "100%",
    minHeight: "100vh",
  },

  ["@media screen and (max-height: 618px)"]: {
    overflow: "scroll",
  },
  ["@media screen and (max-height: 300px)"]: {
    bottom: "4px",
  },
  "&.hidden": {
    width: "1px",
    height: "1px",
    opacity: "0",
    right: theme.spacing(-2),
    bottom: theme.spacing(-2),
  },
}));

export const HelpAndSupportSpacer = styled("div")(() => ({
  flexGrow: 1,
}));

/* SKELETON STYLED COMPONENTS */
export const SkeletonContainer = styled(Stack)(({ theme }) => ({
  height: "564px",
  borderRadius: theme.custom.radius[1],
}));

export const SkeletonHeader = styled(Skeleton)(({ theme }) => ({
  borderRadius: `${theme.custom.radius[1]} ${theme.custom.radius[1]} 0px 0px`,
  marginTop: "0px!important",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "0px",
  },
}));

export const SkeletonCloseBtn = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  zIndex: 9,
  right: "21px",
  top: "21px",
  color: theme.palette.grey[200],
  ["svg"]: {
    fontSize: "1.375rem",
  },
}));

export const ChatButton = styled(Button)(({ theme }) => ({
  "&:disabled": {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[200],
  },
}));
